<template>
  <o-table
    :items="trackersWithConfig"
    :loading="loading"
    defaultSort="number"
    :draggable="false"
    paginated
    :per-page="100"
  >
    <b-table-column v-slot="{ index }" cell-class="has-text-grey">
      {{ index + 1 }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="number" label="Numéro" sortable>
      <b-tooltip :label="`IMEI : ${row.imei}`" type="is-light" position="is-right">
        <span class="has-text-weight-medium">{{ row.number }}</span>
      </b-tooltip>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="availability" label="Status" sortable>
      <b-tag :type="tags[row.availability].type">
        {{ tags[row.availability].label }}
      </b-tag>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="wear" label="Usure" sortable>
      <b-tooltip
        :label="wears.find((wear) => wear.value === row.wear).label"
        type="is-light"
        position="is-right"
      >
        <b-icon :icon="wearIcons[row.wear].icon" size="is-small" :type="wearIcons[row.wear].type" />
      </b-tooltip>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="model" label="Modèle" sortable>
      {{ queclinkModels[row.model] }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="owner" label="Propriétaire" sortable>
      {{ capitalize(row.owner) }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="config.isInitialized" label="Initialisé" sortable>
      <b-icon v-if="row.config?.isInitialized" size="is-small" type="is-success" icon="check" />
      <b-icon v-else size="is-small" type="is-danger" icon="times" />
    </b-table-column>
    <b-table-column v-slot="{ row }" field="config.isSynchronized" label="Synchronisé" sortable>
      <b-icon v-if="row.config?.isSynchronized" size="is-small" type="is-success" icon="check" />
      <b-icon v-else size="is-small" type="is-danger" icon="times" />
    </b-table-column>

    <b-table-column v-slot="{ row }" field="locatedAt" label="Dernier point" sortable>
      {{ formatDate(row.locatedAt) }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="batteryPercentage" label="Batterie" sortable>
      <o-battery-level-indicator
        v-if="row.batteryPercentage"
        :battery-percentage="row.batteryPercentage"
      />
      <span v-else>–</span>
    </b-table-column>

    <b-table-column v-slot="{ row }" label="">
      <div class="buttons are-small is-right">
        <b-button
          type="is-primary"
          tag="router-link"
          :to="{ name: 'queclinkTracker.edit', params: { id: row.id } }"
        >
          <b-icon icon="edit" />
        </b-button>
      </div>
    </b-table-column>
  </o-table>
</template>

<script>
import { capitalize } from '@helpers/capitalize'
import OTable from '@components/Table.vue'
import { format } from 'date-fns'
import { TAGS } from '@constants/tracker/tag'
import { QUECLINK_MODELS } from '@constants/tracker/model'
import { WEARS, WEAR_ICONS } from '@constants/tracker/wear'
import OBatteryLevelIndicator from '@components/BatteryLevelIndicator.vue'

export default {
  name: 'ListQueclinkTrackersTable',

  components: {
    OTable,
    OBatteryLevelIndicator,
  },

  props: {
    queclinkTrackers: {
      type: Array,
      required: true,
    },
    queclinkTrackerConfigs: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  created() {
    this.tags = TAGS
    this.queclinkModels = QUECLINK_MODELS
    this.wears = WEARS
    this.wearIcons = WEAR_ICONS
  },

  computed: {
    trackersWithConfig() {
      const configs = new Map(this.queclinkTrackerConfigs.map((config) => [config.id, config]))

      return this.queclinkTrackers.map((tracker) => ({
        ...tracker,
        config: configs.get(tracker.id),
      }))
    },
  },

  methods: {
    capitalize(value) {
      return capitalize(value)
    },
    formatDate(date) {
      return !date ? 'Aucune date' : format(date, 'dd/MM/yyyy')
    },
  },
}
</script>
